import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlice: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSlice"><Path d="M6.00015 2.58569L1.58594 6.99991L6.58594 11.9999L3.58594 14.9999L4.29304 15.707C7.38148 18.7955 10.0581 20.3127 12.8278 20.7974C15.5595 21.2755 18.2482 20.7187 21.2427 19.97L22.9561 19.5417L6.00015 2.58569Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSlice;
